import { render, staticRenderFns } from "./cardShowNews.vue?vue&type=template&id=a0f10d92&scoped=true"
import script from "./cardShowNews.vue?vue&type=script&lang=js"
export * from "./cardShowNews.vue?vue&type=script&lang=js"
import style0 from "./cardShowNews.vue?vue&type=style&index=0&id=a0f10d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f10d92",
  null
  
)

export default component.exports